module.exports = __webpack_public_path__ + "static/media/_percent.d0b127ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_percent.jpg
// module id = 56
// module chunks = 0